import { DATA_STS_KEY, DATA_STS_UNCHANGED } from './constants'
import { isObject } from 'lodash'

export default function markUnchanged (data: object) {
  if (!isObject(data)) return
  if (DATA_STS_KEY in data) {
    data[DATA_STS_KEY] = DATA_STS_UNCHANGED
  }
  for (const propKey in data) {
    const propValue = data[propKey]
    if (!isObject(propValue)) continue
    markUnchanged(propValue)
  }
}